import { FC } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { Button } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Heading } from "capitalrx-components-2.0/lib/typography";

import { CompoundItem } from "./CompoundItem";

export const CompoundSection: FC = () => {
  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "compound_pricing",
  });

  const onAddCompoudItem = () => {
    append({ type: null, value: null });
  };

  const onRemoveCompoundItem = (id: number): void => {
    remove(id);
  };
  return (
    <Stack>
      <Heading>Compound</Heading>
      {fields.map((action, idx) => (
        <CompoundItem index={idx} key={action.id} onDelete={onRemoveCompoundItem} />
      ))}
      <Shelf>
        <Button appearance="text" icon="add" iconPosition="left" size="small" onClick={onAddCompoudItem}>
          Add Field
        </Button>
        <Shelf.Spacer />
      </Shelf>
    </Stack>
  );
};
